import type { ReactNode } from "react";

type Props = {
	children: ReactNode;
};

const PageContainer = ({ children }: Props) => (
	<main className="flex grow justify-center p-4 pb-20">
		<section className="mx-auto w-full max-w-[1140px] px-0">{children}</section>
	</main>
);

export default PageContainer;
